<template>
  <!--eslint-disable-->
  <DxPopup
    width="60vw"
    height="60vh"
    popupMaxHeight="80vh"
    :animation="null"
    :visible="true"
    :shading="false"
    :resizeEnabled="true"
    :minWidth="450"
    :toolbarItems="toolbarItems"
    @shown="onShown"
  >
    <template #titleTemplate>
      <PopupTitleTemplate
        text="Импорт компонентов"
        :showCloseButton="true"
        @closeClick="$emit('hidden')"
      />
    </template>
    <template>
      <div class="popup-import-settings-form-content">
        <div class="dx-field">
          <div class="dx-field-label">Родитель</div>
          <div class="dx-field-value">
            <ComponentSearchSelectBox v-model="parentComponentId" />
          </div>
        </div>
        <div class="dx-field dx-field-json">
          <div class="dx-field-label dx-field-label-file">JSON</div>
          <div class="dx-field-value dx-field-value-json">
            <MonacoEditorBase
              class="popup-import-settings-form-content__json"
              :options="monacoEditorOptions"
              v-model="componentJson"
            />
          </div>
        </div>
      </div>
    </template>
  </DxPopup>
</template>

<script>
import DxPopup from 'devextreme-vue/popup';
import PopupTitleTemplate from '../Containers/PopupTitleTemplate';
import ComponentSearchSelectBox from './ComponentSearchSelectBox';
import MonacoEditorBase from '../MonacoEditorBase';
import { jsonRPC } from '@/api/api';

export default {
  components: {
    DxPopup,
    ComponentSearchSelectBox,
    PopupTitleTemplate,
    MonacoEditorBase
  },
  data() {
    return {
      parentComponentId: '',
      componentJson: '',
      monacoEditorOptions: {
        language: 'json',
        automaticLayout: true,
        autoIndent: true,
        formatOnPaste: true,
        formatOnType: true,
        minimap: {
          enabled: false
        }
      },
      toolbarItems: [
        {
          toolbar: 'bottom',
          location: 'center',
          widget: 'dxButton',
          options: {
            text: 'Импортировать',
            type: 'success',
            onClick: () => {
              this.apply();
            }
          }
        },
        {
          toolbar: 'bottom',
          location: 'center',
          widget: 'dxButton',
          options: {
            text: 'Отменить',
            onClick: () => {
              this.$emit('hidden');
            }
          }
        }
      ]
    };
  },
  methods: {
    apply() {
      this.$store.commit('setLoading', true);
      const url = this.$store.getters['config/getPageUrl'];
      const obj = JSON.parse(this.componentJson);
      return jsonRPC('getData', {
        body: obj,
        component_parent_id: this.parentComponentId,
        device: this.$store.getters['uiConstructor/resolutionDevice'],
        url,
        _config_dataset: 'CONFIG.PRCLONECOMPONENTBYAPI'
      })
        .then(() => {
          this.$emit('hidden');
          if (this.parentComponentId) {
            //Обновление компонента вставки
            const parentConfig = this.$store.getters['config/getItem'](this.parentComponentId);
            const grandParentComponentId = parentConfig.parentComponentId;
            return this.$store.dispatch('config/loadComponent', {
              componentId: this.parentComponentId,
              parentComponentId: grandParentComponentId
            });
          } else {
            //Обновление всей страницы
            return this.$store.dispatch('config/loadPageConfig', {
              pageUrl: url,
              oldPageUrl: url,
              device: this.$store.getters['uiConstructor/resolutionDevice'] || 'desktop',
              urlParams: this.$route.query
            });
          }
        })
        .finally(() => {
          this.$store.commit('setLoading', false);
        });
    },
    onShown() {
      this.parentComponentId = this.$store.getters['config/selectedComponentId'];
      this.$emit('shown');
    }
  }
};
</script>

<style lang="scss">
.popup-import-settings-form-content {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__json {
    height: 100%;
  }

  .dx-field {
    display: flex;
    flex: 0 0 auto;

    & > .dx-field-label {
      float: none;
      width: auto;
      flex: 0 0 90px;
    }
    & > .dx-field-value {
      float: none;
      width: auto;
      flex: 1 1 auto;

      & > .dx-checkbox {
        float: none;
      }
    }
    .dx-field-value-json {
      flex: 1;
    }
  }
  .dx-field-json {
    flex: 1;
  }
}
</style>
